// src/components/Footer.jsx
import React from 'react';
import '../utils/Footer.css'; // Asegúrate de que el archivo CSS exista y esté correctamente configurado
import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa'; // Librería react-icons

const Footer = () => {
  return (
    <footer className="homepage-footer">
      <p>Desarrollado por PoliDevs | &copy; 2025. Todos los derechos reservados.</p>
      
      <div className="social-icons">
        <a href="https://www.facebook.com/profile.php?id=61559322495642" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaFacebook />
        </a>
        <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaTwitter />
        </a>
        <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaInstagram />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
